import * as immutable from 'immutable';
import { Injectable } from '@angular/core';
import {FILTERS_STORAGE_KEY} from "@ispm/shared/services/ui-customization.service";
import {Filter, FilterAndCategories} from "../classes/filter";

@Injectable()
export class FilterUtils {
  public static getFilterTypes(filterTypes: string): string[] {
    return filterTypes.split('_');
  }

  public static buildFilterTypes(filterType: string, filterSubtypes: string[]): string {
    return filterType + '_' + filterSubtypes.join('_');
  }

  public static loadFromSessionCache = function () {
    const sessionFilters: string = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    const storedFilters = JSON.parse(sessionFilters);

    let applied;
    let defaultCategories;
    let appliedFilterProperties;
    let currentSelected;
    let currentSelectedQuery;
    let currentSelectedFormData;
    let currentSelectedConfig;
    let current;
    let currentSelectedTab;

    if (storedFilters) {
      applied = storedFilters.applied ? immutable.Seq(storedFilters.applied).toMap() : immutable.Map<string, immutable.Map<string, Filter>>();
      defaultCategories = storedFilters.defaultCategories ? immutable.Seq(storedFilters.defaultCategories).toMap() : immutable.Map<string, any>();
      appliedFilterProperties = storedFilters.appliedFilterProperties ? immutable.Seq(storedFilters.appliedFilterProperties).toMap() : immutable.Map<string, any[]>();
      currentSelected = storedFilters.currentSelected ? immutable.Seq(storedFilters.currentSelected).toMap() : immutable.Map<string, FilterAndCategories>();
      currentSelectedQuery = storedFilters.currentSelectedQuery ? immutable.Seq(storedFilters.currentSelectedQuery).toMap() : immutable.Map<string, any>();
      currentSelectedFormData = storedFilters.currentSelectedFormData ? immutable.Seq(storedFilters.currentSelectedFormData).toMap() : immutable.Map<string, any>();
      currentSelectedConfig = storedFilters.currentSelectedConfig ? immutable.Seq(storedFilters.currentSelectedConfig).toMap() : immutable.Map<string, any>();
      current = storedFilters.current;
      currentSelectedTab = storedFilters.currentSelectedTab;
    }

    return {
      applied: applied,
      defaultCategories: defaultCategories,
      appliedFilterProperties: appliedFilterProperties,
      currentSelected: currentSelected,
      currentSelectedQuery: currentSelectedQuery,
      currentSelectedFormData: currentSelectedFormData,
      currentSelectedConfig: currentSelectedConfig,
      current: current,
      currentSelectedTab: currentSelectedTab
    };
  };
}
